import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Close } from "../../images/black-close.svg";
import { ReactComponent as Eye } from "../../images/eye.svg";
import { ReactComponent as ClosedEye } from "../../images/eye-close.svg";

import logo from "../../images/logo.svg";

import Modal from "../assets/Modal";
import StyledForm from "../assets/StyledForm";
import StyledModal from "./StyledModal";
import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";
import ksa from "../../images/flags/ksa.png";

const RegisterModal = ({}) => {
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({});
  const [passwordType, setPasswordType] = useState("password");

  function isArabic(text) {
    var pattern = /[\u0600-\u06FF\u0750-\u077F]/;
    let result = pattern.test(text);
    return result;
  }

  return (
    <Modal urlKey={"signup"}>
      <StyledModal>
        <div className="header">
          <button
            className="close-btn"
            onClick={() => {
              navigate(location.pathname);
            }}
          >
            <Close />
          </button>
          <Link to="/">
            <img src={logo} className="logo" alt="logo" />
          </Link>
        </div>
        <div className="title-text">
          <p className="title">{t.carPage.registerModal.title}</p>
          <p className="text">{t.carPage.registerModal.text}</p>
        </div>
        <div className="form-container">
          <StyledForm
            onSubmit={(e) => {
              e.preventDefault();
              navigate(location.pathname + "?quotation-success=true");
            }}
          >
            <div className="fields">
              <div className="input-div" key="fullname">
                {formData["fullname"] && (
                  <p className="label">{t.carPage.fullname}</p>
                )}
                <input
                  name="fullname"
                  placeholder={t.carPage.fullname}
                  type={"text"}
                  required={true}
                  onChange={(e) =>
                    setFormData({
                      ...formData,

                      fullname: e.target.value,
                    })
                  }
                  className={`${
                    isArabic(formData["fullname"]) ? "arabic-input" : ""
                  } ${formData["fullname"] ? "label_active" : ""}`}
                  value={formData["fullname"] || ""}
                />
              </div>

              <div className="input-div" key="mobile">
                <div
                  className={`mobile-input-div ${
                    formData["mobile"] ? "label-active" : ""
                  }`}
                >
                  {formData["mobile"] && (
                    <p className="label">{t.carPage.mobile}</p>
                  )}
                  <div
                    className="phone-input-container"
                    style={{
                      position: "relative",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span
                      className="country-code-prefix"
                      style={{
                        position: "absolute",
                        left: language === "ar" ? "auto" : "12px",
                        right: language === "ar" ? "12px" : "auto",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#333",
                        fontSize: "16px",
                        fontWeight: "500",
                        zIndex: 1,
                        pointerEvents: "none",
                      }}
                    >
                      <img src={ksa} alt="ksa" style={{ width: "20px" }} /> +966
                    </span>
                    <input
                      name="mobile"
                      placeholder={t.carPage.mobile}
                      type="text"
                      inputMode="numeric"
                      pattern="\d{9}"
                      required={true}
                      maxLength={9}
                      onKeyDown={(e) => {
                        if (["e", "-", "+", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 9);
                        setFormData({
                          ...formData,
                          mobile: value,
                        });
                      }}
                      style={{
                        paddingLeft: language === "ar" ? "12px" : "90px",
                        paddingRight: language === "ar" ? "90px" : "12px",
                        width: "100%",
                      }}
                      value={formData["mobile"] || ""}
                    />
                  </div>
                </div>
              </div>
              <div className="input-div" key="password">
                {formData["password"] && (
                  <p className="label">{t.carPage.password}</p>
                )}
                <input
                  name="password"
                  placeholder={t.carPage.createPassword}
                  type={passwordType}
                  required={true}
                  onChange={(e) =>
                    setFormData({
                      ...formData,

                      password: e.target.value,
                    })
                  }
                  className={`password-input ${
                    formData["password"] ? "label_active" : ""
                  }`}
                  value={formData["password"] || ""}
                />
                <button
                  className="password-icon"
                  onClick={(e) => {
                    e.preventDefault();
                    passwordType == "password"
                      ? setPasswordType("text")
                      : setPasswordType("password");
                  }}
                >
                  {passwordType == "password" ? <ClosedEye /> : <Eye />}
                </button>
              </div>
            </div>
            <div className="btn-container" AvailabilityCard>
              <button className="submit" type="submit">
                {t.carPage.availability.requestQuotation}
              </button>
            </div>
          </StyledForm>
        </div>
        <div className="switch">
          <p>{t.authPages.haveAcount}</p>
          <button
            className="signup"
            onClick={() => {
              navigate(location.pathname + "?login=true");
            }}
          >
            {t.authPages.login}
          </button>
        </div>
      </StyledModal>
    </Modal>
  );
};

export default RegisterModal;
